import gql from "graphql-tag";

export const FullCustomerBenefitFragment = gql`
    fragment FullCustomerBenefit on CustomerBenefit {
        id
        slug
        stage

        title
        headline
        description

        podcasts {
            id
            title
            shortdescription
            publicationDate
        }

        sections(orderBy: sortIndex_ASC) {
            id
            slug

            headline
            description
            table
            localizedHotspotImage {
                handle
                fileName
                width
                height
                url
                mimeType
            }

            hotspotImage(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }

            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY

                headline
                description
            }

            assetsWithDescription(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
        }
    }
`;

export default gql`
    query CustomerBenefit($slug: String!, $lang: Locale!, $stage: Stage!) {
        customerBenefit(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullCustomerBenefit
        }
    }
    ${FullCustomerBenefitFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/customerBenefit.js